import { FormControl, InputLabel, TextField } from "@mui/material";
import { DesktopDateTimePicker } from "@mui/x-date-pickers";
import { Controller } from "react-hook-form";

const ControlledFormDateTime = ({
  dateTimePickerProps,
  control,
  defaultValue,
  id,
  label,
  name,
  readonly,
  trigger,
  ...props
}) => {
  return (
    <Controller
      control={control}
      defaultValue={defaultValue}
      name={name}
      render={({ field: { onChange, ref, value } }) => (
        <FormControl>
          <InputLabel>{label}</InputLabel>
          <DesktopDateTimePicker
            format={"dd-MMM-yyyy (hh:mm:ss a)"}
            onChange={onChange}
            readOnly={!!readonly}
            renderInput={(params) => (
              <TextField variant="standard" {...params} />
            )}
            sx={{ minWidth: "16em" }}
            value={value}
            {...dateTimePickerProps}
          />
        </FormControl>
      )}
      {...props}
    />
  );
};
export { ControlledFormDateTime };
